import { createContext, useContext } from 'react';
import type { Translation } from './translations';

export const LocaleContext = createContext<Translation | null>(null);

export function useTranslation(): Translation {
  const t = useContext(LocaleContext);
  if (!t) {
    throw new Error('useTranslation must be used within LocaleProvider');
  }
  return t;
}
